import moment from 'moment'

export const DashboardPendingPayrollsContainerComponent = {
    template: `
        <apex-dashboard-pending-payrolls ng-if="$ctrl.loaded && $ctrl.page.Entities.length"
                                         pending-payrolls="$ctrl.page"
                                         on-dismiss="$ctrl.onDismiss($event)"
                                         on-change-page="$ctrl.onChangePage($event)">
        </apex-dashboard-pending-payrolls>`,
    require: {
        dashboardContext: "?^apexDashboardContent"
    },
    controller: class DashboardPendingPayrollsContainer {
        constructor(payrollService, utilityService) {
            'ngInject'
            this.payrollService = payrollService
            this.utilityService = utilityService
            this.pageIndex = 0
            this.pageSize = 10
            this.loaded = false
            this.filters = {
                // Don't load more than the last 2 weeks of pending payrolls
                start: moment().add(-2, "weeks").toDate(),
                locked: false,
                sort: ['StartDateDesc', 'Owner'],
                dismissed: false
            }
        }

        $onInit() {
            this.payrollService.retrievePayrollsPage(this.filters, this.pageIndex, this.pageSize)
                .then(page => {
                    this.page = page
                    this.loaded = true

                    if (this.dashboardContext) {
                        this.dashboardContext.activateDashboard({
                            visible: this.page.TotalEntityCount > 0,
                            count: this.page.TotalEntityCount
                        })
                    }
                })
        }

        onChangePage({ pageIndex }) {
            this.pageIndex = pageIndex
            const loading = this.payrollService.retrievePayrollsPage(this.filters, this.pageIndex, this.pageSize)
                .then(page => {
                    this.page = page
                })
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loading, "Changing page failed")
            )
        }

        onDismiss({ payroll }) {
            payroll.IsDismissed = true
            const saving = this.payrollService.dismissPayrollPendingMessage(payroll.PayrollID)

            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(saving, "Dismissal failed"))
        }
    }
}
